import type { UseFormReturn } from "react-hook-form";

import type { FormData } from "../shared/IntakeTypes";
import { useIntakeValidation } from "./useIntakeValidation";

type UseIntakeNavigationParams = {
  methods: UseFormReturn<FormData>;
  page: number;
  setPage: (page: number) => void;
};

export const useIntakeNavigation = ({
  methods,
  page,
  setPage,
}: UseIntakeNavigationParams) => {
  const { showFieldValidationErrors } = useIntakeValidation();

  const handleNext = async (fieldsToValidate: (keyof FormData)[]) => {
    const isValid = await methods.trigger(fieldsToValidate);
    if (!isValid) {
      const errors = methods.formState.errors;
      showFieldValidationErrors(fieldsToValidate, errors);
      return;
    }

    setPage(page + 1);
  };

  const handlePrev = () => {
    setPage(page - 1);
  };

  return {
    handleNext,
    handlePrev,
  };
};
